export const SET_BOOKMARK_REQUEST ="SET_BOOKMARK_REQUEST";
export const SET_BOOKMARK_SUCCESS ="SET_BOOKMARK_SUCCESS";
export const SET_BOOKMARK_FAILURE ="SET_BOOKMARK_FAILURE";

export const GET_BOOKMARK_REQUEST ="GET_BOOKMARK_REQUEST";
export const GET_BOOKMARK_SUCCESS ="GET_BOOKMARK_SUCCESS";
export const GET_BOOKMARK_FAILURE ="GET_BOOKMARK_FAILURE";

export const REMOVE_BOOKMARK_REQUEST ="REMOVE_BOOKMARK_REQUEST";
export const REMOVE_BOOKMARK_SUCCESS ="REMOVE_BOOKMARK_SUCCESS";
export const REMOVE_BOOKMARK_FAILURE ="REMOVE_BOOKMARK_FAILURE";
